<template>
	<div>
		<div v-if="!isShow">
			<slot></slot>
		</div>
		<div class="poster-bac" :class="[isFixHeight ? 'isFixHeight' : '']" v-if="isShow" @touchstart="handlerTouchstart"
			@touchmove="handlerTouchmove" @touchend="handlerTouchend">
			<img class="poster-image" :src="posterUrl" alt="">
			<i class="close-icon"></i>
		</div>
	</div>
</template>
<script>
export default {
	props: {
		posterUrl: {
			type: String,
			default: '',
		},
		isShow: {
			type: Boolean,
			default: () => false
		},
		isFixHeight: {
			type: Boolean,
			default: true
		},
		isStarMember: {
			type: Number,
			default: 0
		}
	},
	data() {
		return {
			loop: 0,
			clickShow: false,
			longClickShow: false
		}
	},
	methods: {
		handlerTouchstart() {
			this.loop = setTimeout(() => {
				this.loop = 0
				// 执行长按要执行的内容


			}, 500) // 定时的时间
			return false
		},
		handlerTouchmove() {
			// 清除定时器
			clearTimeout(this.loop)
			this.loop = 0
		},
		handlerTouchend() {
			// 清除定时器
			clearTimeout(this.loop)
			if (this.loop !== 0) {
				// 单击操作
				this.$emit('OnCancelPoster', false)
			}
		},
		handleCancelPoster() {
			this.$emit('OnCancelPoster', false)
		},
	}
}
</script>
<style>
.van-popup--center {
	background: transparent;
}
</style>
<style lang="less" scoped>
.poster-bac {
	position: relative;
	width: 100%;
	z-index: 100;
	text-align: center;
	background: #00000050;
	display: flex;

	.close-icon {
		position: absolute;
		width: 64px;
		height: 64px;
		top: 40px;
		right: 10px;
		background: url('../../assets/images/winterGame/close.png') no-repeat center center;
		background-size: 100% 100%;
		&.star-member {
			top: 90px;
			right: 20px;
		}
	}
}

.poster-image {
	display: block;
	width: 100%;
	// height: 100%;
	// margin: auto;

}

.poster-bac.isFixHeight {
	height: 100vh;

	.poster-image {
		max-width: 100vw;
		// height: 100%;
		margin: auto;
	}
}
</style>
